import type { Auftrag } from '@awf/shared';
import { nameAus } from '../ui/begruessung.js';

/**
 * Gehoert der Auftrag jemand anderem? Nur moeglich in einer Gesamtansicht (Rollen `admin` und
 * `technik`); dann
 * zeigt die Oberflaeche ihn zum Lesen und blendet Entscheiden, Bearbeiten und Loeschen aus.
 * Ohne bekannte uid gilt er als eigener -- die Pruefung ist reine Anzeige, das Recht setzt das
 * Backend durch (`eigenerAuftrag` in apps/backend/src/runs-route.ts).
 */
export function istFremd(auftrag: Pick<Auftrag, 'ownerUid'>, uid: string | null | undefined) {
  return Boolean(uid) && auftrag.ownerUid !== uid;
}

/**
 * Spalte "Angelegt von": Anzeigename, sonst der Name aus `vorname.nachname@` (wie die Begruessung),
 * zuletzt die Adresse. Der eigene Auftrag heisst "Sie".
 */
export function angelegtVon(
  auftrag: Pick<Auftrag, 'ownerUid' | 'ownerName' | 'ownerEmail'>,
  uid: string | null | undefined,
): string {
  if (uid && auftrag.ownerUid === uid) return 'Sie';
  // Nur in der Gesamtansicht `alle` (Rolle `technik`): Auftraege, die n8n ohne Besitzer meldet.
  if (auftrag.ownerUid === 'system') return 'System';
  return auftrag.ownerName || nameAus(auftrag.ownerEmail) || auftrag.ownerEmail || 'Unbekannt';
}

/**
 * Ein "geloeschter" Auftrag bleibt als Dokument stehen und zaehlt zur Monatsnutzung (`ausgeblendetAm`
 * in packages/shared). Jede Anzeige filtert ihn mit diesem Praedikat heraus; nur die Nutzung zaehlt
 * ihn. Gefiltert wird beim Verbraucher, nicht in der Quelle: Die Deckel-Pruefungen (`>= HOL_GRENZE`)
 * muessen die rohe Trefferzahl sehen, denn ausgeblendete belegen Plaetze unter der Grenze.
 */
export function istSichtbar(auftrag: Pick<Auftrag, 'ausgeblendetAm'>): boolean {
  return !auftrag.ausgeblendetAm;
}

/** Hinweis an fremden Auftraegen, wer entscheidet -- auf Detail- und Entscheidungsseiten gleich. */
export const NUR_ANSICHT_TEXT =
  'Sie sehen diesen Auftrag zur Ansicht. Freigaben und Entscheidungen trifft die Person, die ihn angelegt hat.';
